import React from 'react';
import { Navigate } from 'react-router';
import { NavLink } from 'react-router-dom';
import Base from './Base'

export class Home extends Base {
    constructor(props) {
        super(props);
        this.state = {
            data: null,
            loading: true
        }
    }
    componentDidMount() {
        this.httpPost("api/v1/dashboard")
        .then(data => {
            if (data.status === -1) window.location.href = "/login";
            if (data.status === 1) {
                this.setState({
                    data: data,
                    loading: false
                })
            }
            else {
                this.showErorrMessage(data.message);
                this.setState({
                    loading: false
                });
            }
        });
    }
    renderForm() {
        return <div>
                    <h5>{this.state.data.currentCompany.fname} {this.state.data.currentCompany.lname} عزیز خوش آمدید</h5>
            <div className="row" style={{"margin-top": "60px"}}>
                        <div className="col-md-3">
                            <NavLink to="/customers" className="BoxButton" title="لایسنسها">
                                <img src="/assets/img/customer_large.png" />
                                <p>{ this.state.data.customer_count } مشتری ثبت شده</p>
                            </NavLink>
                        </div>
                        <div className="col-md-3">
                            <NavLink to="/notifications" className="BoxButton" title="اطلاعیه ها">
                                <img src="/assets/img/comment.png" />
                        <p>{this.state.data.notifications_count } اطلاعیه ثبت شده</p>
                            </NavLink>            
                </div>
            </div>
               </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />
        let contents = this.state.loading ? this.renderLoading() : this.renderForm();

        return (
            <div>
                {this.state.lockScreen === 1 && this.lockScreen()}
                {this.getToastContainer()}
                {contents}
            </div>
        );
    }
}